import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { GridApi } from 'ag-grid-community';

@Component({
  selector: 'lib-custom-page-size-controller',
  templateUrl: './custom-page-size-controller.component.html',
  styleUrls: ['./custom-page-size-controller.component.scss']
})
export class CustomPageSizeControllerComponent implements OnInit {

  @Input() public options = [25, 50, 100, 250];
  @Input() public showPageSizeChangeController: "enable" | "disable" = "enable";
  @Input() public isSearchApiData: boolean = false;
  @Output() public onChange: EventEmitter<any> = new EventEmitter();

  public SEARCH_INDEX_MAX_RESULT_WINDOW: number = 10000;
  public gridApi: GridApi;
  public pageSize: number;
  public firstDisplayedRowIndex: number;
  public lastDisplayedRowIndex: number;
  public totalRows: number;

  get pageStatus() {
    const fromItem = this.totalRows === 0 ? 0 : this.firstDisplayedRowIndex + 1;
    const toItem = this.lastDisplayedRowIndex + 1;
    return `${fromItem} - ${toItem}`;
  }

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit() {
  }

  gridReady(api: any) {
    this.gridApi = api;
    this.gridApi.addEventListener('modelUpdated', () => {
      this.updatePageStatus();
    })
  }

  selectChangeHandler(event) {
    let selectedPagesize = (event || {}).option.value;
    this.pageSize = selectedPagesize;
    if (selectedPagesize && this.gridApi) {
      this.gridApi.paginationSetPageSize(selectedPagesize);
      this.updatePageStatus();
    }
    this.onChange.emit(selectedPagesize);
  }

  updatePageStatus() {
    if (this.gridApi) {
      this.totalRows = this.gridApi.paginationGetRowCount();
      this.firstDisplayedRowIndex = this.gridApi.getFirstDisplayedRow();
      this.lastDisplayedRowIndex = this.gridApi.getLastDisplayedRow();
      this.pageSize = this.gridApi.paginationGetPageSize();
      this.cd.detectChanges();
    }
  }
}
